import { z } from 'zod';

export const storageLocationSchema = z.object({
  name: z.string().min(1, { message: 'Name is required' }),
  tank: z.string().optional().default(''),
  row: z.string().optional().default(''),
  canister: z.string().optional().default(''),
  locationType: z.coerce.number({
    required_error: 'Location Type is required',
  }),
  siteId: z.string().min(1, { message: 'Site is required' }),
  siteName: z.string().optional().default(''),
});

export type StorageLocationFormValues = z.infer<typeof storageLocationSchema>;
